export default {
  all: 'Todos',
}
